import Step4 from './Step4-compose';

export default Step4;
